import {
  Box,
  Button,
  Flex,
  Grid,
  IconButton,
  Spacer,
  Modal,
  ModalOverlay,
  ModalContent,
  Center,
  Image,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useColorModeValue,
  FormLabel,
  Input,
  Spinner,
  HStack,
  VStack,
  TableContainer,
  Heading,
  Select,
} from "@chakra-ui/react";
import {
  createColumnHelper,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table";
// Custom components
import Card from "components/Card/Card";
import { BsTrash, BsPencil } from "react-icons/bs";
import { BiNotification, BiSliderAlt } from "react-icons/bi";
import "./TableSector.css";

import * as React from "react";
// Assets
import useInventory from "hooks/use-inventory";
import { formatedDate, formatedDateBr } from "helpers/formated";
import useGeneral from "hooks/use-general";
import ModalHistoricInventory from "../inventory/components/ModalHistoricInventory";
import CategorySelect from "../inventory/components/SelectCategory";
import useManagerProduct from "hooks/use-manager-product";
// import CategorySelect from "./SelectCategory";
// import ModalHistoricInventory from "./ModalHistoricInventory";

type RowObj = {
  id: number;
  storeId: number;
  receivingSectorId: number;
  beginDate: string;
  endDate: string;
  userId: any;
  updatedAt: string;
  storeDescription: string;
  receivingSectorDescription: string;
};

const columnHelper = createColumnHelper<RowObj>();

// const columns = columnsDataCheck;
export default function Managers(props: { tableData: any }) {
  const { tableData } = props;
  const {
    data,
    dataCombo,
    getData,
    getDataCombo,
    isFirstData,
    postData,
    deleteData,
    putData,
    loading,
  } = useManagerProduct();
  const { data: dataStore } = useGeneral();
  const parseValueSelect = (id: number) => {
    const valueOption = dataStore.find((item) => item.value === id);
    return valueOption;
  };
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const textColor = useColorModeValue("black", "white");
  const textColorInvert = useColorModeValue("black", "black");

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isOpen, setIsOpen] = React.useState(false);
  const [centro, setCentro] = React.useState({ label: "", value: 0 });
  const [categoria, setCategoria] = React.useState("1");
  const [de, setDe] = React.useState("");
  const [ate, setAte] = React.useState("");
  const [idSelect, setIdSelect] = React.useState("");
  const [isOpenDeleted, setIsOpenDelete] = React.useState(false);

  const [selectedName, setSelectedName] = React.useState("");

  const handleSelectChange = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setSelectedName(event.target.value);
  };
  const handleClose = () => {
    setIdSelect("");
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleCloseDelete = () => {
    setIsOpenDelete(false);
  };
  const handleSubmit = () => {
    const inventory = {
      ProductManagerId: selectedName,
    };
    setDe("");
    setAte("");
    setCategoria("1");
    setCentro({ label: "", value: 0 });
    setSelectedName("");
    postData(inventory);
    handleClose();
  };

  const handleOpenDelete = () => {
    setIsOpenDelete(true);
  };
  const handleDelete = React.useCallback(() => {
    deleteData(Number(idSelect));
    handleCloseDelete();
  }, [deleteData, idSelect]);

  const getInventoryIdEdit = React.useCallback(
    (id: any) => {
      setIdSelect(id);
      debugger;
      const user = data.find((item: { id: number }) => item.id === Number(id));
      setCentro(user?.storeId);
      setCategoria(user?.receivingSectorId);
      debugger;
      setDe(formatedDate(user?.beginDate));
      setAte(formatedDate(user?.endDate));
      handleOpen();
    },
    [data]
  );

  const columns = [
    columnHelper.accessor("storeId", {
      id: "storeId",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          CENTRO
        </Text>
      ),
      cell: (info: any) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("receivingSectorDescription", {
      id: "receivingSectorDescription",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          CATEGORIA
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm">
            {info.getValue()}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("beginDate", {
      id: "beginDate",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          Período Inicial
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text justifyContent="space-between" color={textColor} fontSize="sm">
            {formatedDateBr(info.getValue())}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("endDate", {
      id: "endDate",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          Período Final
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text justifyContent="space-between" color={textColor} fontSize="sm">
            {formatedDateBr(info.getValue())}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor("id", {
      id: "id",
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: "10px", lg: "12px" }}
          fontWeight="bold"
        >
          Ação
        </Text>
      ),
      cell: (info) => (
        <Flex justifyContent="space-between" alignItems="center">
          <Flex>
            <Box pr={3}>
              <IconButton
                icon={<BsTrash />}
                aria-label="Excluir"
                variant="outline"
                size="sm"
                onClick={() => {
                  handleOpenDelete();
                  setIdSelect(info.getValue().toString());
                }}
                colorScheme="red"
              />
            </Box>

            <IconButton
              icon={<BsPencil />}
              aria-label="Editar"
              variant="outline"
              size="sm"
              colorScheme="teal"
              onClick={() => {
                getInventoryIdEdit(info.getValue().toString());
              }}
            />
          </Flex>
        </Flex>
      ),
    }),
  ];
  // const [data, setData] = React.useState(() => [...defaultData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  React.useEffect(() => {
    if (isFirstData) {
      getData();
      getDataCombo();
    }
  });
  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex px="5px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        ></Text>

        {/* <Menu /> */}
        <Stack direction={{ base: "column", md: "row" }} spacing="34px" p={6}>
          <Button colorScheme="green" variant="outline" onClick={handleOpen}>
            Associar
          </Button>
        </Stack>
      </Flex>
      <Modal isOpen={isOpenDeleted} onClose={handleCloseDelete}>
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Center>
              <Image
                width="80%"
                src="https://cdn.dribbble.com/users/592004/screenshots/2953817/media/ee885c68f4e39db8c72e3bbbaeca454f.gif"
              />
            </Center>

            <Center>
              <h1>Deseja realmente dissociar esse registro?</h1>
            </Center>
            <Center>Esta ação é irreversível.</Center>
          </ModalBody>
          <ModalFooter>
            <Flex justifyContent="center" width="100%">
              <Button variant="ghost" onClick={handleCloseDelete}>
                Cancelar
              </Button>
              <Button colorScheme="red" mr={3} onClick={handleDelete}>
                Dissociar
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpen} onClose={handleClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={"gray.200"}
            background={"#1d5840"}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {idSelect !== "" ? (
                  <>Associar Gerentes</>
                ) : (
                  <> Associar Gerentes</>
                )}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton color="white" />
          <ModalBody>
            <Flex>
              <Box pl={2} pr={2}>
                <FormLabel fontWeight={700}>Nome: </FormLabel>
                <Select
                  placeholder="Selecionar Gerente"
                  onChange={handleSelectChange}
                  width={400}
                >
                  {dataCombo.map((manager) => (
                    <option
                      key={manager.productManagerId}
                      value={manager.productManagerId}
                    >
                      {manager.name}
                    </option>
                  ))}
                </Select>
              </Box>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={handleClose}>
              Fechar
            </Button>
            <Button
              colorScheme="green"
              ml={3}
              isDisabled={selectedName === ""}
              onClick={handleSubmit}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Flex justify="flex-end"></Flex>
      {loading ? (
        <>
          <Box>
            <Center>
              <HStack>
                <Spinner />
                <br></br>
                <Stack direction="column" align="center">
                  <span>Buscando Dados Aguarde...</span>
                </Stack>
              </HStack>
            </Center>
          </Box>
        </>
      ) : isMobile ? (
        // Exibir os cards em versões mobile
        <Box overflowX={{ base: "auto", md: "visible" }} maxH="400px">
          <Grid
            templateColumns="repeat(auto-fit, minmax(200px, 1fr))"
            gap={4}
            p={4}
          >
            {data.map((item: any) => (
              <Flex key={item.code} direction="row">
                <Box
                  borderWidth="3px"
                  borderRadius="md"
                  p={4}
                  boxShadow="base"
                  _hover={{ boxShadow: "xl" }}
                  flex="1"
                >
                  <Stack spacing={2}>
                    <Box as="strong">
                      <Flex>
                        <Text color="gray.400">{item?.storeId} </Text>
                        <Text>- {item?.storeDescription}</Text>
                      </Flex>
                    </Box>
                    <Box>
                      <BiNotification />
                      Categoria: {item?.receivingSectorDescription}
                    </Box>
                    <Box>De: {formatedDateBr(item?.beginDate)}</Box>
                    <Box>Ate: {formatedDateBr(item?.endDate)}</Box>
                    <hr></hr>
                    <Flex justifyContent="space-between" alignItems="center">
                      <Flex>
                        <Box pr={3}>
                          <IconButton
                            icon={<BsTrash />}
                            aria-label="Excluir"
                            variant="outline"
                            size="sm"
                            colorScheme="red"
                            onClick={() => {
                              handleOpenDelete();
                              setIdSelect(item?.id);
                            }}
                          />
                        </Box>

                        <IconButton
                          icon={<BsPencil />}
                          aria-label="Editar"
                          variant="outline"
                          size="sm"
                          colorScheme="teal"
                          onClick={() => {
                            getInventoryIdEdit(item?.id);
                          }}
                        />
                      </Flex>
                    </Flex>
                  </Stack>
                </Box>
              </Flex>
            ))}
          </Grid>
        </Box>
      ) : (
        // Exibir a tabela em versões desktop
        <Box overflowX="auto">
          <Box>
            <TableContainer>
              <Table
                className="custom-table"
                variant="simple"
                color="gray.500"
                mb="24px"
                mt="12px"
              >
                <Thead>
                  <Tr>
                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                    >
                      ID
                    </Th>
                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                    >
                      Nome
                    </Th>

                    <Th
                      color={textColorInvert}
                      textAlign="center"
                      fontWeight="bold"
                      textTransform="uppercase"
                    >
                      Ação
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {data.map((item) => (
                    <Tr>
                      <Td color={textColor} scope="row">
                        {" "}
                        {item.productManagerId}
                      </Td>
                      <Td color={textColor} scope="row" textAlign="center">
                        {item?.name}
                      </Td>

                      <Td textAlign="center">
                        {" "}
                        <Center>
                          <Box pr={3}>
                            <IconButton
                              icon={<BsTrash />}
                              aria-label="Excluir"
                              variant="outline"
                              size="sm"
                              colorScheme="red"
                              onClick={() => {
                                handleOpenDelete();
                                setIdSelect(item?.productManagerId);
                              }}
                            />
                          </Box>
                        </Center>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      )}
    </Card>
  );
}
